/* eslint-disable */
export function Validations(actionCallback, name, value) {

    if (name === 'email') {
        if (/^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(value)) {

            return actionCallback(true)
        }
        else {
            return actionCallback(false)
        }
    }
}

class Validator {

    constructor(){

        this.errors = { allFields: 0 }
        this.validate = this.validate.bind(this)
    }

    validate({ name, value, required, type }){

        if(!this.errors.hasOwnProperty(name)){ this.errors.allFields++ }

        if(required){
            this.errors[name] = value.toString().trim().length > 0? false: true
            if(this.errors[name]){ return this.errors }
        }

        switch(type){

            case 'email':
                this.errors[name] =
                    (this.emailChecker.test(value))?
                    false:
                    true
                break

            case 'number':
                this.errors[name] =
                    (this.numberChecker.test(value))?
                    false:
                    true
                break
                
            case 'password':
                this.errors[name] =
                    (this.passwordChecker.test(value))?
                    false:
                    true
                break

            case 'select':
                this.errors[name] =
                    (!!value) && value.toString().trim().length > 0?
                    false:
                    true
                break

            case undefined:
                this.errors[name] =
                    value.toString().trim().length > 0?
                    false:
                    true
                break
        }

        return this.errors
    }

    //Regex

    emailChecker = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/

    passwordChecker = /^(?=.*[0-9])(?=.*[!@#$%^&*])(?=.*[A-Z])(?=.*[a-z])[a-zA-Z0-9!@#$%^&*]{8,16}$/

    mobileChecker = /^\d{10}$/

    numberChecker = /^[0-9]*$/

    pinCodeChecker = /(^\d{6}$)|(^\d{6}-\d{5}$)/

    //Error texts

    emailError = 'Email is not valid'

    mobileError = 'Enter a valid mobile number'

    numError = 'Enter a valid number'

    reqError = 'This field is mandatory'

    pwdError = 'Password does not match the conditions'
}

export const validator = new Validator()

export const Error = Validator

export const errorParser = serverErrors => {

    let errors = {}
    if(typeof serverErrors === 'object'){
        serverErrors.forEach(err => {
            errors[err.fieldName] = err.defaultMessage
        })
    }

    return errors
}


// WEBPACK FOOTER //
// ./src/components/common/validations.js